
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA, CELLTIPO_FECHAHORA,
    CELLTIPO_FOREIGN, CELLTIPO_HORA, CELLTIPO_ICONOACCION, CELLTIPO_LISTA, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import {CAMPOTIPO_CADENA} from "../../framework2/ej2/UI/TiposCampos";
import Formulario from "../../framework2/ej2/UI/Formulario";
import {getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import FormularioBotonera, {
    BOTONERA_ACCION_EXCEL,
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR, BOTONERA_PDF,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import PropTypes from "prop-types";
import {
    loadDatosServicio,
    renderFormulario,
    renderGrid,
    showInputBusqueda,
    showSelectBusqueda
} from "../utils/FormularioUtils";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Tratamiento from "./Tratamiento";
import Paciente from "./Paciente";
import {getPeriodoUltimoAgnoTimestamp} from "../../framework2/ej2/utils/PeriodoUtils";
import Cita from "../citas/Cita";
import {exportarPdf, exportarPdfLocalEmpresaSvg} from "../../framework2/ej2/utils/ExportarUtils";
import {
    calcularColumnasSinPdfCampo,
    calcularDatosConPdfCampo,
    calcularDatosConPie
} from "../../framework2/ej2/utils/DatosUtils";
import {citaavisoestados} from "../utils/Definiciones";
import {generatePdfFromTable} from "../../framework2/ej2/pdf/GeneradorPdf3";
import {
    extraerColumnasTitulosEstilos,
    extraerDatosValores,
    extraerDatosValoresPieEstilos, generarColumnStyles
} from "../../framework2/ej2/pdf/TableUtils";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {getFormattedDateInversaFromDate} from "../../framework2/ej2/utils/DateUtils";

class CitasLista extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            filtroNombre: null,
            filtroCodigoid: null,
        }


        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                }
            },
            {campo:"fechainicio", titulo: "Fecha", tipo: CELLTIPO_FECHA, ancho:140},
            {campo:"fechainicio", titulo: "Inicio", tipo: CELLTIPO_HORA, ancho:50},
            {campo:"fechafin", titulo: "Fin", tipo: CELLTIPO_HORA, ancho:50},
            {campo:"pacienteCodigo.nombre", titulo: "Paciente", tipo: CELLTIPO_CADENA, ancho:200,},
            {campo:"doctorCodigo.nombre", titulo: "Doctor", tipo: CELLTIPO_CADENA, ancho:100,},
            {campo:"clinicaCodigo.nombre", titulo: "Clinica", tipo: CELLTIPO_CADENA, ancho:100,},
            {campo:"avisoestado", titulo: "Estado", tipo: CELLTIPO_LISTA, valores: citaavisoestados, ancho:100,},
            {campo:"texto", titulo: "Texto", tipo: CELLTIPO_CADENA, ancho:320, },
        ];
        //Si estamso viendo las citas de un paciente no hace falta mostrar la columna del nombre del paciente
        if (props.paciente)
            this.columnas.splice(3, 1);

    }

    componentDidMount() {
        if (this.props.paciente || this.props.fecha)
            this.loadDatos();
    }


    loadDatos= () =>{
        const {estado, paciente, fecha} = this.props;
        console.log("CitasLista - LoadDatos");
        console.log ("fecha", fecha);
        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            pacienteCodigo: paciente ? paciente.codigo : 0,
            fecha: fecha ? getFormattedDateInversaFromDate(fecha) : null,
            
            //doctorCodigo: filtroDoctorCodigo ? filtroDoctorCodigo : 0,
            //fechas: filtroFechas,
        }
        console.log ("CITASLISTA LoadDatos");
        console.log("paramertos: ", parametros);
        loadDatosServicio(this, "Cita", "getCitas", parametros);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_PDF:
                //this.exportarPdfLocal();
                this.exportarPdfRemoto();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }

    exportarPdfLocal= () => {
        const {datos} = this.state;
        const {titulo} = this.props;

        let columnasPdf=this.columnas.slice(2);
        columnasPdf = columnasPdf.filter(obj => obj.campo !== "clinicaCodigo.nombre" &&  obj.campo !== "doctorCodigo.nombre");
        let pdfConfig={
            columnas: columnasPdf,
            datos: datos,
            titulo: titulo,
            stripped: true,
        }
        exportarPdf(pdfConfig);

    }


    exportarPdfLocal2= () => {
        const {datos} = this.state;
        const {titulo} = this.props;

        let columnasPdf=this.columnas.slice(2);
        columnasPdf = columnasPdf.filter(obj => obj.campo !== "clinicaCodigo.nombre" &&  obj.campo !== "doctorCodigo.nombre");

        let datosFormateados= null;
        if (datos && columnasPdf) {
            datosFormateados = extraerDatosValores(datos, columnasPdf);
        }
        console.log("titulo: ", titulo);
        console.log("datosFormateados: ", datosFormateados);
        generatePdfFromTable(columnasPdf, datosFormateados, titulo, "citas.pdf", true);

    }

    exportarPdfRemoto= () => {
        const {estado, paciente, fecha} = this.props;

        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            pacienteCodigo: paciente ? paciente.codigo : 0,
            fecha: fecha ? fecha : null,
        }
        console.log ("CITASLISTA LoadDatos");
        console.log("parametros: ", parametros);

        let url= servidor + "minimo/ej2/citasdiapdf/";
        console.log("loadDatosServicio ", url);
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( parametros,response => {
            console.log("response: ", response);
        });
    }


    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }

    onSalir= () => {
        const {onSalir} = this.props;
        onSalir && onSalir();
    }
    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    gridEstilizadorRow= (elemento) => {
        //console.log(" >>>> gridEstilizadorRow");
        //console.log("elemento: ", elemento);
        if (elemento.doctorCodigo && elemento.doctorCodigo.color)
            return {backgroundColor: elemento.doctorCodigo.color};
        else
            return {backgroundColor: '#FFFFFF'};
    };

    renderBusqueda= () => {
        const {filtroNombre, filtroCodigoid} = this.state;
        const {datosmaestros} = this.props;
        return (
            <div class="fr_contenedor_buscador" >
                {showInputBusqueda("codigoid", "Código", filtroCodigoid,
                    (codigoid) => this.setState({filtroCodigoid: codigoid}),
                    this.loadDatos, this.inputCodigoIdRef) }
                {showInputBusqueda("nombre", "Nombre", filtroNombre,
                    (nombre) => this.setState({filtroNombre: nombre.toUpperCase()}),
                    this.loadDatos) }
                <button className="fr_boton refrescar"onClick={this.loadDatos}>Refrescar</button>
            </div>
        );
    }

    render() {
        const {showGrid, datos} = this.state;
        const {paciente, titulo} = this.props;
        let tituloReal= titulo ? titulo : "Gestión de Pagos";
        //let soloTitulo=

        let propiedadesRenderGrid= {
            estilizadorRow: this.gridEstilizadorRow,
            mostrarBotonNuevo: !paciente,
            mostrarBotonera: false,
        };

        return (
            <div style={{margin: 8, padding: 4}}>
                {!paciente && <Titulo titulo={tituloReal} soloTitulo={true} onVolver={this.onSalir}/>}
                {/*!paciente && this.renderBusqueda()*/}
                {Boolean(showGrid) && renderGrid(this, "Citas", datos, this.onAccion, propiedadesRenderGrid)}
                {Boolean(showGrid) &&
                    <FormularioBotonera
                        numElementos={datos ? datos.length : 0}
                        showAcciones={[BOTONERA_REFRESCAR, BOTONERA_PDF]}
                        onAccion={this.onAccion}
                    />
                }
                {!Boolean(showGrid) && renderFormulario(this, <Cita/>)}

            </div>
        )
    }

}

CitasLista.propTypes = {
    paciente: PropTypes.object,
    fecha: PropTypes.number,
    onSalir: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(CitasLista);



